import { render, staticRenderFns } from "./Offers.vue?vue&type=template&id=1b18fa06&scoped=true&"
import script from "./Offers.vue?vue&type=script&lang=ts&"
export * from "./Offers.vue?vue&type=script&lang=ts&"
import style0 from "./Offers.vue?vue&type=style&index=0&id=1b18fa06&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b18fa06",
  null
  
)

export default component.exports